"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestStatusPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RequestStatusTypes = _interopRequireDefault(require("../RequestStatusTypes"));

var requestStatusPropType = _propTypes.default.oneOf(Object.values(_RequestStatusTypes.default));

exports.requestStatusPropType = requestStatusPropType;